export class ContaAReceber {}
